import { CarbonOperation } from "src/app/shared/interfaces/carbon-operation";

export interface EmitClickConfirmation {
  type: ClickEnumConfirmation,
  row: CarbonOperation
}

export enum ClickEnumConfirmation {
  APROVAR = 'aprovar',
  REJEITAR = 'rejeitar',
  DETALHES = 'detalhes'
}
